import { useState } from "react";
import { useAuth } from "../auth";
import { errorText } from "../hooks";

export function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [needCode, setNeedCode] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(username, password, needCode ? code : undefined);
    } catch (err) {
      const msg = errorText(err);
      if (msg === "two-factor code needed") { setNeedCode(true); setError(null); }
      else setError(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="page" style={{ maxWidth: 380, marginTop: "10vh" }}>
      <div className="card">
        <h1>visualTools-lite</h1>
        <form onSubmit={submit} style={{ display: "grid", gap: "0.8rem" }}>
          <label>Username<input autoFocus autoComplete="username" value={username}
            onChange={(e) => setUsername(e.target.value)} /></label>
          <label>Password<input type="password" autoComplete="current-password" value={password}
            onChange={(e) => setPassword(e.target.value)} /></label>
          {needCode && (
            <label>Code from your authenticator app<input autoFocus inputMode="numeric" autoComplete="one-time-code"
              value={code} onChange={(e) => setCode(e.target.value)} /></label>
          )}
          {error && <div className="error">{error}</div>}
          <button disabled={busy || !username || !password || (needCode && code.length < 6)}>Sign in</button>
        </form>
      </div>
    </main>
  );
}
